import apiClient from "@/api/apiClient";
import type { PartModelConstraint } from "@/supabase.types";
import {
  createPaginatedSupabaseQuery,
  spawnCreateApiFunction,
  spawnDeleteApiFunction,
  spawnGetApiFunction,
  spawnUpdateApiFunction,
  type ApiResourceConfig,
} from "@/utils/api";
import type { QueryPaginationFilters } from "@/utils/pagination";

const table = "part_model_constraints";
const query = `
                *,
                quantity_below_min,
                quantity_above_max,
                quantity_equals_min,
                quantity_equals_max,
                part_model:part_models(
                  *,
                  part_manufacturer:part_manufacturers(*),
                  part_category:part_categories(*)
                ),
                search_pm1:part_models(name),
                search_pm2:part_models(description),
                search_pm3:part_models(ref)
              `;
export const apiConfigPartModelConstraints: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: ["title", "description", "search_pm1.name", "search_pm2.description", "search_pm3.ref"],
  sortables: [
    "title",
    "created_at",
    "updated_at",
    "min_quantity",
    "max_quantity",
    "part_model.name",
    "quantity_below_min",
    "quantity_above_max",
    "quantity_equals_min",
    "quantity_equals_max",
  ],
};

export const getPartModelConstraint = spawnGetApiFunction({ table, query });
export const createPartModelConstraint = spawnCreateApiFunction({ table, query });
export const updatePartModelConstraint = spawnUpdateApiFunction({ table, query });
export const deletePartModelConstraint = spawnDeleteApiFunction({ table });

export const getPartModelConstraintsByMatch = async (match: Partial<PartModelConstraint>) => {
  const { data, error } = await apiClient.from(table).select(query).match(match);
  if (error) throw error;
  return data;
};

export async function getPaginatedPartModelConstraints({
  dataTableOptions,
  customFilters,
  customOrFilters,
}: QueryPaginationFilters) {
  const { data, count, error } = await createPaginatedSupabaseQuery({
    baseOptions: {
      table,
      query,
      searchables: apiConfigPartModelConstraints.searchables,
      sortables: apiConfigPartModelConstraints.sortables,
    },
    dataTableOptions,
    customFilters,
    customOrFilters,
  });
  if (error) throw error;
  return { data, count };
}

export async function getPaginatedExceededPartModelConstraints({
  dataTableOptions,
  customFilters,
  customOrFilters,
}: QueryPaginationFilters) {
  const { data, count, error } = await createPaginatedSupabaseQuery({
    baseOptions: {
      table,
      query,
      searchables: apiConfigPartModelConstraints.searchables,
      sortables: apiConfigPartModelConstraints.sortables,
      orFilters: [
        `quantity_below_min.is.true, quantity_above_max.is.true, quantity_equals_min.is.true, quantity_equals_max.is.true`,
      ],
    },
    dataTableOptions,
    customFilters,
    customOrFilters,
  });
  if (error) throw error;
  return { data, count };
}
